import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Projects" }
const _hoisted_2 = { class: "Projects__side" }
const _hoisted_3 = { class: "Projects__search" }
const _hoisted_4 = { class: "Projects__list" }

import { computed } from "vue";
import ProjectCreate from "./ProjectCreate.vue";
import { useProjectStore } from "@/stores/projects";
import ProjectCard from "@/components/pages/projects/card/ProjectCard.vue";
import ProjectFilter from "@/components/pages/projects/ProjectFilter.vue";
import YearTotals from "@/components/pages/projects/year-totals/YearTotals.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const projectsStore = useProjectStore();

const list = computed(() => {
    return projectsStore.sorted;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ProjectCreate),
      (_unref(projectsStore).year !== '*')
        ? (_openBlock(), _createBlock(YearTotals, {
            key: 0,
            year: _unref(projectsStore).year
          }, null, 8, ["year"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ProjectFilter),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (project) => {
            return (_openBlock(), _createElementBlock("li", {
              key: project.id
            }, [
              _createVNode(ProjectCard, { project: project }, null, 8, ["project"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})